import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type StartDeleteAssetsOperationMutationVariables = Types.Exact<{
  input: Types.StartDeleteAssetsOperationInput;
}>;


export type StartDeleteAssetsOperationMutation = { __typename?: 'Mutation', startDeleteAssetsOperation?: { __typename?: 'StartDeleteAssetsOperationPayload', assetOperation?: { __typename?: 'CopyAssetsOperation', id?: string | null } | { __typename?: 'DeleteAssetsOperation', id?: string | null } | { __typename?: 'HardDeleteAssetsOperation', id?: string | null } | { __typename?: 'MoveAssetsOperation', id?: string | null } | { __typename?: 'UpdateAssetFieldValuesOperation', id?: string | null } | null } | null };


export const StartDeleteAssetsOperation = /*#__PURE__*/ gql`
    mutation StartDeleteAssetsOperation($input: StartDeleteAssetsOperationInput!) {
  startDeleteAssetsOperation(input: $input) {
    assetOperation {
      id
    }
  }
}
    ` as unknown as DocumentNode<StartDeleteAssetsOperationMutation, StartDeleteAssetsOperationMutationVariables>;

          

          export const useStartDeleteAssetsOperationMutation = (options?:MutationHookOptions<StartDeleteAssetsOperationMutation, StartDeleteAssetsOperationMutationVariables>) => useMutation(StartDeleteAssetsOperation, options);
          

          export type StartDeleteAssetsOperationMutationOptions = MutationHookOptions<StartDeleteAssetsOperationMutation, StartDeleteAssetsOperationMutationVariables>;

          

          export type StartDeleteAssetsOperationMutationResult = ReturnType<typeof useStartDeleteAssetsOperationMutation>[1];

          
